import get from 'lodash.get';
import { localStorage } from 'dibs-browser-storage';
import { graphql } from 'react-relay';

const viewerFragment = graphql`
    fragment userGeoInfo_regionalInfo on Viewer {
        regionalInfo {
            zipCode
        }
    }
`;

const USER_ZIP_CODE = 'userGeoInfo';
// valid period is set to 30 days
const USER_ZIP_CODE_VALID_PERIOD = 2592000000;

function hasValidLocalUserGeoInfo({ isZipCodeResolverEnabled }) {
    if (isZipCodeResolverEnabled) {
        const regionalInfo = localStorage.getItem(USER_ZIP_CODE);
        const zipCode = get(regionalInfo, 'zipCode');
        // checking if zipCode is set
        // "0" is valid zipCode set from digital elements for private IP addresses
        if (zipCode || zipCode === 0) {
            // Check if 30 days passed
            if (Date.now() - regionalInfo.timestamp <= USER_ZIP_CODE_VALID_PERIOD) {
                return true;
            }
        }
        return false;
    }
    return true;
}
function getLocalUserGeoInfo() {
    const zipCode = localStorage.getItem(USER_ZIP_CODE);
    return get(zipCode, 'zipCode');
}

function setLocalUserGeoInfo(viewer) {
    const zipCode = get(viewer, 'user.profile.zipCode') || get(viewer, 'regionalInfo[0].zipCode');
    localStorage.setItem(USER_ZIP_CODE, {
        zipCode,
        timestamp: Date.now(),
    });
}

export { setLocalUserGeoInfo, hasValidLocalUserGeoInfo, getLocalUserGeoInfo, viewerFragment };
